<template>
  <div>
    <b-alert :show="true" variant="light">
      <div class="iq-alert-text" v-html="message"></div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'WDMessage',
  props: ['message']
}
</script>
